







import { Vue, Prop, Component } from 'vue-property-decorator';
import Project from '@/domain/project/project.entity';
import RandomColor from '@/shared/utils/random-color';
import NameSplit from '@/shared/utils/name-split';

@Component
export default class ProjectAvatarComponent extends Vue {
  @Prop({ required: true }) project?: Project;

   @Prop() size?: number;

  private color = RandomColor.get();

  get name(): string {
    if (this.project && this.project.name) {
      return NameSplit.formatName(this.project.name);
    }
    return '';
  }
}
